<template>
  <div id="tableFixed" class="tableFixed">
    <table class="table no-margin">
      <thead>
        <tr>
          <VueHeader @click="headerClick" v-for="(column, index) in columns" :key="index" :sort="sort" :column="column" :options="options"></VueHeader>
        </tr>
      </thead>
      <tbody v-if="scrollInfinite" class="table no-margin bodyInfinite" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="50">
        <VueRow v-if="hasData" v-for="(row, index) in pageRows" :key="index" :row="row" :columns="columns" @click="rowClick" :options="options"></VueRow>
      </tbody>
      <tbody class="table no-margin" v-if="!scrollInfinite">
        <VueRow v-if="hasData" v-for="(row, index) in pageRows" :key="index" :row="row" :columns="columns" @click="rowClick" :options="options"></VueRow>
        <tr v-if="!hasData && !isLoading">
          <td :colspan="columns.length" style="vertical-align: top!important;">
            <va-alert type="warning" style="width: 100%;">
              <div slot="header">
                <i class="icon fa fa-warning"></i> No Data Found !
              </div>
            </va-alert>
          </td>
        </tr>
        <tr v-if="hasData && isLastPage">
          <td :colspan="columns.length" style="height: 100%!important;"></td>
        </tr>
        <loading :active.sync="isLoading" :is-full-page="isFullpage"></loading>
      </tbody>
      <tfoot class="table no-margin">
        <tr>
          <td style="border: none; padding: 0px;" :colspan="columns.length">
            <div class="box-footer clearfix">
              <div v-if="hasPaging" class="box-tools pull-left">
                <ul class="pagination pagination-sm inline">
                  <li class="noClick"><a href="#" disabled="disabled">Total rows: {{rows.length}}</a></li>
                </ul>
              </div>
              <div class="box-tools pull-left" v-if="info">
                <div class="pull-left divInfo" v-for="item in info"><i :class="[item.icon]"></i> {{item.label}}</div>
                <!--<ul class="pagination pagination-sm inline">
                  <li class="noClick" v-for="item in info"><span class="noselect">{{item.label}}</span></li>
                </ul>-->
              </div>

              <div v-if="hasPaging" class="box-tools">
                <div class="box-tools pull-left" style="padding: 0px 10px;">
                  <div class="pull-left divInfo">Rows per page:</div>
                  <select class="form-control" v-model="pageSize" style="padding-left: 0px; width: 70px; height: 30px; border-radius: 5px; color: #666; background-color: #fafafa;">
                    <option v-for="(size,index) in pageSizes" :value="size">{{ size }}</option>
                  </select>
                </div>
                <ul v-show="totalPages>1" class="pagination pagination-sm inline">
                  <li><a @click="nextPage(-1)" class="noselect">&laquo;</a></li>
                  <li v-for="page in filteredTotalPages"><a @click="currentPage=page" :class="['noselect', page===currentPage?'activePage':'']">{{page}}</a></li>
                  <li><a @click="nextPage(1)" class="noselect">&raquo;</a></li>
                </ul>
              </div>
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
  import sort from 'fast-sort'
  import VueHeader from './TableHeader.vue'
  import VueRow from './TableRow.vue'
  import VAAlert from '../../components/VAAlert.vue'
  import Loading from 'vue-loading-overlay'
  export default {
    name: 'VueTable',
    props: ['guid', 'columns', 'rows', 'options', 'info', 'isLoading', 'isPaging'],
    components: { VueHeader, VueRow, 'va-alert': VAAlert, Loading },
    data () {
      return {
        scrollInfinite: false,
        data: [],
        visibleRows: [],
        busy: false,
        isFullpage: false,
        currentPage: 1,
        pageSizeX: 10000,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100, 200, 500, 1000, 5000],
        sort: {
          fieldName: '',
          order: ''
        }
      }
    },
    created () {
      console.log('VueTable created ...')
      this.currentPageSize = this.pageSize
    },
    mounted () {
      console.log('VueTable mounted ...')
    },
    updated () {
      console.log('VueTable updated ...')
      // console.log('VueTable guid = ' + this.guid)
      this.currentPage > this.totalPages ? this.currentPage = this.totalPages : this.currentPage = this.currentPage
      this.currentPage < 1 && this.totalPages > 0 ? this.currentPage = 1 : this.currentPage = this.currentPage
    },
    computed: {
      hasData () {
        return (this.rows !== null && this.rows !== undefined && this.rows.length > 0)
      },
      totalPages () {
        if (this.rows && this.rows.length >= 0) {
          let totalP = this.rows.length / this.pageSize
          return Math.ceil(totalP)
        } else {
          return 0
        }
      },
      hasPaging () {
        if (this.isPaging === false) {
          return false
        } else {
          return true
        }
      },
      filteredTotalPages () {
        if (this.totalPages > 10) {
          let index10 = Math.floor((this.currentPage - 1) / 10)
          let arr10 = []
          for (let i = 1; i <= 10; i++) {
            let pageIndex = i + index10 * 10
            if (pageIndex <= this.totalPages) {
              arr10.push(i + index10 * 10)
            }
          }
          return arr10
        } else {
          return this.totalPages
        }
      },
      pageRows () {
        if (this.rows && this.rows.length >= 0) {
          let startIndex = (this.currentPage - 1) * this.pageSize
          let endIndex = (this.currentPage) * this.pageSize
          return this.rows.slice(startIndex, endIndex)
        } else {
          return []
        }
      },
      isFirstPage () {
        return (this.currentPage === 1)
      },
      isLastPage () {
        return (this.currentPage === this.totalPages)
      }
    },
    watch: {
      rows (val) {
        // console.log('VueTable changed ...')
        // this.currentPage = 1
      },
      currentPage (val) {
        document.getElementById('tableFixed').scrollTop = 0
      }
    },
    methods: {
      refresh () {
        const vm = this
        vm.isLoading = true
        vm.key = vm.$root.getGUID()
        vm.$forceUpdate()
        setInterval(function () {
          vm.isLoading = false
        }, (1000))
      },
      nextPage (num) {
        if (this.currentPage === 1 && num < 0) { return }
        if (this.currentPage === this.totalPages && num > 0) { return }
        this.currentPage += num
      },
      headerClick (column) {
        if (column.isSortable) {
          this.changeSorting(column)
        }
        if (column.isBotton) {
          console.log('this.$emit(column.funcName)')
          console.log('column.funcName = ' + column.funcName)
          // this.$emit(column.funcName)
          this.$emit('headerClick', column.funcName)
        }
      },
      changeSorting (column) {
        console.log('changeSorting....')
        console.log(column)
        if (column.isSortable) {
          let sortFieldName = ''
          if (column.sortFieldName) {
            sortFieldName = column.sortFieldName
          } else {
            sortFieldName = column.fieldName
          }
          if (this.sort.fieldName !== sortFieldName) {
            this.sort.fieldName = sortFieldName
            this.sort.order = 'asc'
          } else {
            this.sort.order = (this.sort.order === 'asc' ? 'desc' : 'asc')
          }
          console.log('sortFieldName = ' + sortFieldName)
          console.log('this.sort.fieldName = ' + this.sort.fieldName)
          console.log('this.sort.order = ' + this.sort.order)
          if (this.sort.order === 'asc') {
            sort(this.rows).asc(this.sort.fieldName)
          } else {
            sort(this.rows).desc(this.sort.fieldName)
          }
          this.$forceUpdate()
        }
      },
      rowClick (btn, row) {
        console.log('rowClick....')
        console.log(btn)
        console.log(row)
        this.$emit('rowClick', btn, row)
      },
      loadMore () {
        console.log('loadMore() ...')
        const vm = this
        vm.busy = true
        let start = vm.visibleRows.length
        let end = start + 10
        let max = vm.rows.length
        if (start < max) {
          if (end > max) {
            end = max
            console.log('loadMore() load to [end] ' + end)
          }
          for (var i = start; i < end; i++) {
            vm.visibleRows.push(vm.rows[i])
          }
          vm.busy = false
        } else {
          // No more data to load
          vm.busy = false
        }
      }
    }
  }
</script>
<style>

  .tableFixed {
    overflow-y: auto;
    height: 700px;
    float: left;
    width: 100%;
  }

    .tableFixed thead th {
      position: sticky;
      top: 0;
    }

    .tableFixed tfoot tr {
      position: sticky;
      bottom: 0;
    }

  table {
    border-collapse: collapse;
    width: 100%;
    min-height: 500px;
  }

  .bodyInfinite {
    height: 400px;
  }
  .pagination > li {
    cursor: pointer;
  }
  .activePage {
    z-index: 2;
    color: #23527c!important;
    background-color: #eee!important;
    border-color: #ddd!important;
  }
  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
  }
  .sortHeader {
    cursor: pointer;
    white-space: nowrap;
    position: relative;
    /*height: 50px!important;*/
  }

    .sortHeader:hover {
      background-color: #dce7f0;
      color: #3c8dbc !important;
      /*border-radius: 5px;*/
    }
  .divInfo{
    padding: 5px;
  }
  .newLable {
    background-color: #ddd;
    color: black
  }

  .progressBlack {
    background-color: #000;
    color: #fff;
  }

  .progressCyan {
    background-color: #0093D3;
    color: #000 !important;
  }

  .progressMagenta {
    background-color: #CC006B;
    text-align: center;
    color: #000 !important;
  }

  .progressYellow {
    background-color: #FFF10C;
    color: #000 !important;
  }

  .BlackTonerLeft {
    background-color: #000;
    color: #fff !important;
  }

  .CyanTonerLeft {
    background-color: #0093D3;
    color: #000 !important;
  }

  .MagentaTonerLeft {
    background-color: #CC006B;
    text-align: center;
    color: #000 !important;
  }

  .YellowTonerLeft {
    background-color: #FFF10C;
    color: #000 !important;
  }
  .iconInformation {
    font-size: 28px;
    color: #337ab7;
  }

  .iconWarning {
    font-size: 28px;
    color: yellow;
    color: #f39c12;
  }

  .iconError {
    font-size: 28px;
    color: #d73925;
  }
  .smallIcon {
    font-size: 16px;
  }
  .rotate180 {
    -webkit-transform: rotate(180deg); /* Chrome and other webkit browsers */
    -moz-transform: rotate(180deg); /* FF */
    -o-transform: rotate(180deg); /* Opera */
    -ms-transform: rotate(180deg); /* IE9 */
    transform: rotate(180deg);
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?79b7978c